import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-links">
          <Link to="/terms" className="footer-link">Términos de Servicio</Link>
          <span className="footer-separator">•</span>
          <Link to="/privacy" className="footer-link">Política de Privacidad</Link>
          <span className="footer-separator">•</span>
          <Link to="/support" className="footer-link">Soporte</Link>
        </div>
        <div className="footer-copyright">
          <p>&copy; {currentYear} RTB Collect. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
